function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "contact-illustration",
  transform: "translate(-922.998 -1726.504)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_230",
  "data-name": "Group 230",
  transform: "translate(924 1727.507)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1030",
  "data-name": "Path 1030",
  d: "M811.623,629.1s-27.573-3.036-48.307-2.412l5.342-56.712-9.7,1.559-4.217-25.6,39-1.73s2.461,2.114,10.06,1.449c13.949,4.076,30.926,28.676,30.926,28.676l-23.054,9-2.741-5.553Z",
  transform: "translate(-651.472 -480.202)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1031",
  "data-name": "Path 1031",
  d: "M678.042,767.023,599.7,814.111l27.459,41.472s125.952-55.1,113.02-88.56-219.812-38.62-230.819,3.093c-5.342,20.242,84.092,47.717,84.092,47.717Z",
  transform: "translate(-509.126 -593.892)",
  fill: "#ce1212",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1032",
  "data-name": "Path 1032",
  d: "M815.56,484.464c-2.425-7.7,12.28-26.99,24.249-25.3,11.213,1.58,10.988,7.624,13.179,11.386,1.218,2.091,4.744,4.112,5.272,8.118.481,3.66-2.144,5.623-1.792,8.645.349,3,3.221,7.985-.738,10.227-2.917,1.651-2.986-4.2-9.107-5.092-4.455-.646-10.5-1.009-17.25-3.026C822.821,487.462,817.481,490.561,815.56,484.464Z",
  transform: "translate(-686.566 -430.853)",
  fill: "#231f20",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1033",
  "data-name": "Path 1033",
  d: "M600.68,413.528s-4.13-23.15-9.753-21.463,1.968,22.21,1.968,22.21S576.986,423.1,577.872,427.1c.872,3.931,33.438,55.914,42.5,57.812s36.057-1.6,36.057-1.6l-4.217-25.6s-19.918,1.016-25.759-1.73c-20.914-9.831-14.86-54.227-19.646-54.92C601.444,400.284,600.68,413.528,600.68,413.528Z",
  transform: "translate(-548.947 -391.977)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1034",
  "data-name": "Path 1034",
  d: "M754.741,548.321",
  transform: "translate(-651.472 -482.586)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1035",
  "data-name": "Path 1035",
  d: "M609.551,459.864l4.867-2.53s-5.045-15.8-10.184-13.414C600.368,445.718,609.551,459.864,609.551,459.864Z",
  transform: "translate(-563.695 -421.938)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1036",
  "data-name": "Path 1036",
  d: "M595.44,466.846l5.051-2.686s-5.508-16.133-9.773-13.919C586.064,452.656,595.44,466.846,595.44,466.846Z",
  transform: "translate(-555.661 -425.622)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1037",
  "data-name": "Path 1037",
  d: "M581.1,474.743l4.639-3.092s-5.508-16.133-9.773-13.919C571.309,460.147,581.1,474.743,581.1,474.743Z",
  transform: "translate(-547.134 -429.964)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1038",
  "data-name": "Path 1038",
  d: "M623.935,479.533s3.126,5.165,6.922,5.868",
  transform: "translate(-575.663 -442.72)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1039",
  "data-name": "Path 1039",
  d: "M899.541,615.857s18.656,26.541,17.394,33.9c-1.2,7-49.015,31.445-49.015,31.445l-1.344-24.368,19.61-10.753-9.7-21.226Z",
  transform: "translate(-716.286 -521.727)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1040",
  "data-name": "Path 1040",
  d: "M846.128,514.854l3.322-8.286s-6.81-4.955-3.322-12.125a5.012,5.012,0,0,1,6.651.949c.738.843,3.058,4.744,5.061,4.744s8.118-.316,8.013,2.319-1.9,3.374-3.8,2.32c-2,1.792-4.428,3.057-5.9,2.214a83.855,83.855,0,0,0,.035,9.313S848.8,517.073,846.128,514.854Z",
  transform: "translate(-703.859 -450.849)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_58",
  "data-name": "Rectangle 58",
  width: 105.42,
  height: 66.631,
  rx: 12,
  transform: "translate(42.587 108.672) rotate(-4.104)",
  fill: "#dadada",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_25",
  "data-name": "Ellipse 25",
  cx: 9.629,
  cy: 9.629,
  r: 9.629,
  transform: "translate(87.385 133.491)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_39",
  "data-name": "Line 39",
  x2: 28.756,
  y2: 15.003,
  transform: "translate(84.494 172.467)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1041",
  "data-name": "Path 1041",
  d: "M870.77,942.17l12.909,9.84-36.736,24.969-19.378-11.818S862.931,947.426,870.77,942.17Z",
  transform: "translate(-693.678 -710.841)",
  fill: "#ce1212",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1042",
  "data-name": "Path 1042",
  d: "M901.011,965.573l11.949,8.721-40.006,27.828-15.483-6.955Z",
  transform: "translate(-711.009 -724.404)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1043",
  "data-name": "Path 1043",
  d: "M938.445,992.153l10.978,9.348-41.89,44.139,7.609-25.3-5.783-7.953Z",
  transform: "translate(-740.023 -739.809)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1044",
  "data-name": "Path 1044",
  d: "M695.163,915.748l-21.312,12.694,28.287,38.2,23.5-4.948Z",
  transform: "translate(-604.592 -695.528)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1045",
  "data-name": "Path 1045",
  d: "M657.687,956.29,640.4,967.643l26.146,51.59,2.952-31.472,7.222-5.772Z",
  transform: "translate(-585.205 -719.024)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1046",
  "data-name": "Path 1046",
  d: "M794.9,906.839s85.718-43.554,85.718-53.856",
  transform: "translate(-674.744 -659.153)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
})));

function SvgContactIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234.005,
    height: 307.835,
    viewBox: "0 0 234.005 307.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIllustration);
export default __webpack_public_path__ + "static/media/contact-illustration.9e97b11c.svg";
export { ForwardRef as ReactComponent };